import React, { useState, useEffect } from "react";
import api from '../services/api';
import { RadialBarChart, RadialBar, ResponsiveContainer, Legend } from 'recharts';

export default function MediaExecucaoRadial({ label = "Média", ids = "" }) {
    const token = localStorage.getItem('token');
    const [media, setMedia] = useState(0);
    const buscar = () => {
        api({
            method: 'get',
            action: '/slaCompromissoData/mediaExecucao',
            token: token,
            params: { ids: ids }
        })
            .then(response => {
                //                console.log(response.data.data);
                setMedia(response.data.data.media);
            }).catch(err => {
                //console.log(err)
            });
    };

    useEffect(() => {
        buscar();
    }, 
    // eslint-disable-next-line
    []);

    const data = [
        {
            name: label,
            value: media,
            fill: '#1ab7ea'
        }
    ];

    return (
        <div className="card">
            <div className="card-body">
                <ResponsiveContainer width="100%" height={400}>
                    <RadialBarChart
                        cx="50%"
                        cy="50%"
                        innerRadius="30%"
                        outerRadius="80%"
                        barSize={20}
                        data={data}
                        startAngle={0}
                        endAngle={270}
                    >
                        <RadialBar
                            minAngle={15}
                            label={{ position: 'insideStart', fill: '#fff', fontSize: '16px' }}
                            background
                            clockWise
                            dataKey="value"
                        />
                        <Legend
                            iconSize={0}
                            formatter={(value, entry) => `${label}: ${entry.payload.value}%`}
                            wrapperStyle={{ fontSize: '16px', paddingLeft: '10px', paddingTop: '15px' }}
                        />
                    </RadialBarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
